




















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color, TextureKinds, PaintStyle } from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";
import ColorPicker from "./ColorPicker.vue";

@Component({
  components: {
    colorPicker: ColorPicker,
  },
})
export default class FillStyleEditor extends Mixins(ModelEditableMixin) {
  editingSource: PaintStyle;

  @Prop()
  pallet: Color[];

  @Prop({ default: true })
  isNoneSelectable: boolean;

  @Prop({ default: "背景" })
  label: string;

  @Prop({ default: "背景を塗りつぶすか否かを選択します。" })
  shouldFillDescription: string;

  @Prop({ default: "背景色を選択します。" })
  colorDescription: string;

  get color(): Color {
    return this.editingSource
      ? this.editingSource.color
      : undefined;
  }

  set color(value: Color) {
    this.writeProperty(s => s.color = value);
  }

  get shouldFill(): boolean {
    return this.editingSource
      ? (this.editingSource.kind === TextureKinds.Fill)
      : undefined;
  }

  set shouldFill(value: boolean) {
    this.writeProperty(s => {
      s.kind = value ? TextureKinds.Fill : TextureKinds.None;
      // 塗るつぶし有りの指定なのにtransparent指定のままだとPDF生成で色変換できなくてエラーになるので対策している
      if (value && s.color && s.color.value === "transparent") {
        s.color.value = "#FFFFFF";
      }
    });
  }

  get defaultColor(): Color {
    return new Color("#FFFFFF");
  }
}
